import React, { useEffect, useState } from 'react';
import { ProgressBar } from '@edx/paragon';
import PropTypes from 'prop-types';

const CustomProgressBar = ({ value }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setProgress(value);
  }, [value]);

  return (
    <div>
      <div className="tw-flex tw-justify-between tw-items-center tw-mb-2">
        <h6 className="tw-text-lg tw-font-medium tw-text-neutral-1000">Заповнення профілю</h6>
        <span className="tw-text-lg tw-font-medium tw-text-neutral-1000">{progress}%</span>
      </div>

      <div className="tw-relative">
        <ProgressBar
          now={progress}
          className="custom-progress tw-h-3 tw-bg-body tw-rounded-lg tw-overflow-hidden"
        />
      </div>
    </div>
  );
};

CustomProgressBar.propTypes = {
  value: PropTypes.number.isRequired,
};

CustomProgressBar.defaultProps = {
  value: 0,
};

export default CustomProgressBar;
